// Set initial config before triggering any Segment event.
import './initialConfig/index.js'

import {getAdobeMCVisitorID, getAdobeVisitorData} from '@s-ui/segment-wrapper'

import setMiddlewares from './middlewares/index.js'
import analytics from './analytics.js'
import {isClient} from './utils.js'

// Set destination middlewares once Segment script is properly loaded.
isClient && setMiddlewares()

export default analytics
export {getAdobeVisitorData, getAdobeMCVisitorID}
